import React, { useState } from "react";
import styled from "styled-components";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { FaPlus } from "@react-icons/all-files/fa/FaPlus";
import { BiPlus } from "@react-icons/all-files/bi/BiPlus";
import useScreenWidth from "../../../Hooks/useScreenWidth";
import { IconContext } from "@react-icons/all-files/lib";
import { GrFormClose } from "@react-icons/all-files/gr/GrFormClose";

const StyledA = styled.a`
  /* z-index: 1; */
  transform-origin: center;
  box-sizing: border-box;
  color: white;
  position: absolute;
  align-items: center;
  line-height: 1em;
  margin: 0 auto;
  display: block;
  font-family: "DM Sans", sans-serif;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  font-size: 36px;
  background-color: white;
  user-select: none;
  cursor: pointer;
  left: ${(props) => props.x}%;
  top: ${(props) => props.y}%;
  transition: all 0.2s;
  filter: drop-shadow(0px 4px 4px rgba(0.2, 0.1, 0, 0.5));
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  border: 3px solid #1f3b35;
  background-color: #1f3b35;
  &:hover {
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.7));
    border-color: #007f8f;
    background-color: #007f8f;
  }

  &.mobile_close {
    border: 0px solid white;
    background-color: transparent;
    filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0));
    /* height: 16px;
    width: 16px; */
    & > svg > path {
      /* stroke: unset; */
    }
  }

  @media (min-width: 641px) {
    border: 3px solid #1f3b35;
    height: 50px;
    width: 50px;
    ${(props) => (props.rotate ? "height: 31px; width: 31px; " : "")}
    /* ${(props) =>
      props.rotate
        ? "transform: rotate(45deg) translateX(-50%) translateY(0%); height: 31px; width: 31px;"
        : ""} */

    &:hover {
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.5));
    }
  }
  & svg {
    /* border: 1px solid red; */
    & path {
      fill: ${(props) => props.fillColor};
      /* stroke-width: 10; */
      stroke: ${(props) => props.fillColor};
      /* transition: fill 0.4s ; */

      &:hover {
        filter: drop-shadow(1px 4px 4px rgba(0, 0, 0, 0.5));
      }
    }
  }
`;
const Hotspot = (props) => {
  const { screenWidth } = useScreenWidth();
  const [fillColor, setFillColor] = useState("#1f3b35");
  const {
    hotspotData: {
      x,
      y,
      onMouseEnter,
      onMouseLeave,
      closeButton = true,
      rotate,
    },
  } = props;

  const onMouseEnterHandler = () => {
    setFillColor("#007F8F");
    props.onMouseEnter();
  };

  const onMouseLeaveHandler = () => {
    setFillColor("#1f3b35");
    props.onMouseLeave();
  };

  return (
    <>
      {screenWidth < 641 && rotate ? (
        <StyledA
          fillColor="#1f3b35"
          onClick={props.onHotspotClick}
          role="button"
          x={x}
          y={y}
          onMouseEnter={onMouseEnterHandler}
          onMouseLeave={onMouseLeaveHandler}
          rotate={rotate}
          className="mobile_close"
        >
          <GrFormClose shapeRendering="geometricPrecision" />
        </StyledA>
      ) : (
        <StyledA
          fillColor="#fff"
          onClick={props.onHotspotClick}
          role="button"
          x={x}
          y={y}
          onMouseEnter={onMouseEnterHandler}
          onMouseLeave={onMouseLeaveHandler}
          rotate={rotate}
        >
          <IconContext.Provider value={{ size: "50px" }}>
            {rotate ? (
              <GrFormClose />
            ) : (
              <BiPlus shapeRendering="geometricPrecision" />
            )}
          </IconContext.Provider>
        </StyledA>
      )}
    </>
  );
};

export default Hotspot;
